module.exports = __webpack_public_path__ + "img/iPhone-auto.071b591b.webp";